import classNames from "classnames";
import {
    AvatarGroup,
    type AvatarGroupSize,
} from "@design-system/Avatar/AvatarGroup";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { institutionCatalogue } from "@design-system/InstitutionIcon/institutionCatalogue";
import {
    institutionIconSizePixels,
    institutionIconSizes,
    institutionSections,
    institutionStacks,
    type PlaygroundInstitution,
} from "./InstitutionIconPlayground.lib";
import styles from "./InstitutionIconPlayground.module.scss";

const stackSizes: readonly AvatarGroupSize[] = ["xs", "sm", "md"];

const renderStackItem = (item: PlaygroundInstitution) => (
    <InstitutionIcon {...item.source} label={item.label} />
);

/** Every catalogue brand at every size, next to its Figma name and key. */
export const InstitutionIconCatalogueMatrix = () => (
    <>
        {institutionSections.map((section) => (
            <section key={section.id} className={styles.section}>
                <h2 className={styles.sectionTitle}>{section.title}</h2>
                <div className={styles.matrix}>
                    <span className={styles.headerCell}>Name</span>
                    <span className={styles.headerCell}>Key</span>
                    {institutionIconSizes.map((size) => (
                        <span
                            key={size}
                            className={classNames(
                                styles.headerCell,
                                styles.sizeCell,
                            )}
                        >
                            {institutionIconSizePixels[size]}px
                        </span>
                    ))}
                    {section.keys.map((key) => (
                        <div key={key} className={styles.row}>
                            <span>{institutionCatalogue[key].name}</span>
                            <code className={styles.key}>{key}</code>
                            {institutionIconSizes.map((size) => (
                                <span key={size} className={styles.sizeCell}>
                                    <InstitutionIcon
                                        institution={key}
                                        size={size}
                                    />
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
            </section>
        ))}
    </>
);

/** `AvatarGroup` stacks at each group size, including the billing card's +50. */
export const InstitutionIconStacks = () => (
    <section className={styles.section}>
        <h2 className={styles.sectionTitle}>AvatarGroup stacks</h2>
        <div className={styles.stacks}>
            <span />
            {stackSizes.map((size) => (
                <span key={size} className={styles.headerCell}>
                    {size}
                </span>
            ))}
            {institutionStacks.map((stack) => (
                <div key={stack.id} className={styles.row}>
                    <code className={styles.key}>{stack.id}</code>
                    {stackSizes.map((size) => (
                        <AvatarGroup
                            key={size}
                            items={stack.items}
                            getKey={(item) => item.id}
                            getLabel={(item) => item.label}
                            renderAvatar={renderStackItem}
                            max={5}
                            extraCount={stack.extraCount}
                            size={size}
                        />
                    ))}
                </div>
            ))}
        </div>
    </section>
);
